/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { FileOrFolder } from '../../../feature/src/lib/models/fileOrFolder';
import { FittingTreeView } from '../../../feature/src/lib/models/fitting-tree-view-vm';

//#region Convert FileOrFolder to FittingTreeView
export function convertFileOrFolderItemsToTreeViewItems(filesAndFolders: FileOrFolder[]): FittingTreeView[] {
  let items: FittingTreeView[] = [];
  for (let index = 0; index < filesAndFolders?.length; index++) {
    const item = filesAndFolders[index];
    let itemTreeView = convertFileOrFolderItemToTreeView(item);
    items.push(itemTreeView);
  }
  return items;
}

export function convertFileOrFolderItemToTreeView(fileOrFolder: FileOrFolder): FittingTreeView {
  let itemTreeView = new FittingTreeView();
  itemTreeView.id = fileOrFolder.fullPath;
  itemTreeView.text = fileOrFolder.label;
  itemTreeView.expanded = false;
  itemTreeView.isFolder = fileOrFolder.isFolder;
  itemTreeView.image = fileOrFolder.image;
  itemTreeView.scheduleID = fileOrFolder.scheduleID;
  itemTreeView.fittingEntryID = fileOrFolder.fittingEntryID;
  itemTreeView.fittingIDNumber = fileOrFolder.fittingIDNumber;
  itemTreeView.manufacturerName = fileOrFolder.manufacturerName;
  itemTreeView.items = []; // Initialize items as an empty array
  if (fileOrFolder.isFolder && fileOrFolder.fileOrDirectory) {
    var itemTreeViewChild = convertFileOrFolderItemsToTreeViewItems(fileOrFolder.fileOrDirectory);
    if (itemTreeView.items) {
      itemTreeViewChild.forEach((x) => itemTreeView.items!.push(x));
    }
  }
  return itemTreeView;
}
//#endregion

//#region Convert FittingTreeView to FileOrFolder
export function convertTreeViewItemsToFileForlderItems(treeViewItems: FittingTreeView[]): FileOrFolder[] {
  let items: FileOrFolder[] = [];
  for (let index = 0; index < treeViewItems?.length; index++) {
    const item = treeViewItems[index];
    let itemFileOrFolder = convertTreeViewItemToFileOrFolder(item);
    items.push(itemFileOrFolder);
  }
  return items;
}

export function convertTreeViewItemToFileOrFolder(treeViewItem: FittingTreeView): FileOrFolder {
  let fileOrFolder = new FileOrFolder();
  fileOrFolder.fullPath = treeViewItem.id;
  fileOrFolder.label = treeViewItem.text;
  fileOrFolder.isFolder = treeViewItem.isFolder;
  fileOrFolder.scheduleID = treeViewItem.scheduleID;
  fileOrFolder.image = treeViewItem.image;
  fileOrFolder.fittingIDNumber = treeViewItem.fittingIDNumber;
  fileOrFolder.fittingEntryID = treeViewItem.fittingEntryID;
  fileOrFolder.manufacturerName = treeViewItem.manufacturerName;
  fileOrFolder.fileOrDirectory = [];
  if (treeViewItem.items) {
    var itemTreeViewChild = convertTreeViewItemsToFileForlderItems(treeViewItem.items);
    if (fileOrFolder.fileOrDirectory) {
      itemTreeViewChild.forEach((x) => fileOrFolder.fileOrDirectory!.push(x));
    }
  }
  return fileOrFolder;
}
//#endregion

export function getTreeViewItem(treeViewItems: FittingTreeView[], name: string): FittingTreeView | null {
  for (const item of treeViewItems) {
    //the end of a node, we need to pass to the next node
    if (item.id === null) {
      continue;
    }
    const id = item.id.toLocaleLowerCase();
    if (id === name) {
      return item;
    }
    if (item.items) {
      const found = getTreeViewItem(item.items, name);
      if (found) {
        return found;
      }
    }
  }
  return null;
}
